import type { ExecutedFailure } from '@zoom/videosdk';

import { normalizeError } from '../../../utils';

export class ZoomExecutedFailureError extends Error implements ExecutedFailure {
  type;
  errorCode;
  reason;

  constructor(failure: ExecutedFailure) {
    super(`ZoomExecutedFailureError: ${failure.type} | ${failure.errorCode} | ${failure.reason}`);
    this.type = failure.type;
    this.errorCode = failure.errorCode;
    this.reason = failure.reason;
  }
}

/**
 * ExecutedFailure is only a type definition.
 * "reason" is a required parameter, but is optional in some return values.
 */
export function isZoomExecutedFailure(error: unknown): error is ExecutedFailure {
  return typeof error === 'object' && error !== null && 'type' in error && 'errorCode' in error;
}

/**
 * Returns a Zoom error code and {@link ExecutedFailure} tuple if the error is a
 * Zoom {@link ExecutedFailure}, otherwise returns a normalized error.
 */
export function toZoomError(error: unknown): [number, ExecutedFailure] | [null, Error] {
  if (isZoomExecutedFailure(error)) {
    return [error.errorCode, error];
  }

  return [null, normalizeError(error)];
}
